export function isDev() {
    return Boolean(typeof process !== 'undefined' &&
        process.env?.NODE_ENV &&
        process.env.NODE_ENV !== 'production');
}
//# sourceMappingURL=env.js.map